import React from "react";
import CaseCoverageCard from "./caseCoverage/CaseCoverageCard";
import {StageSpinner} from "react-spinners-kit";

const CaseCoverage = ({ caseCoverageData, activeFilters = false, caseCoverageStatus }) => {

  return (
    <div style={{position: "relative"}}>
      {
        (caseCoverageStatus === "fetching") &&
          <div style={
            {position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            left: 0,
            right: 0,
            margin: "0 auto",
            textAlign: "center",
            width: "44px",}
          }>
            <StageSpinner loading={true} color={"#0A195C"} size={40} />
          </div>
      }
      <div className={activeFilters && 'd-flex'} style={{opacity: (caseCoverageStatus === "fetching") && "0.2"}}>
        <CaseCoverageCard
          title={!activeFilters ? "Case Coverage" : "Cases"}
          coveredTitle={!activeFilters ? "Covered Cases" : "Cases are Covered"}
          totalTitle={"Total Cases"}
          coveredPercentage={caseCoverageData?.case_coverage_percentage}
          covered={caseCoverageData?.covered_cases}
          total={caseCoverageData?.total_cases}
          activeFilters={activeFilters}
        />
        <CaseCoverageCard
          title={"Events Coverage"}
          coveredTitle={"Covered Events"}
          totalTitle={"Total Events"}
          coveredPercentage={caseCoverageData?.event_coverage_percentage}
          covered={caseCoverageData?.covered_events}
          total={caseCoverageData?.total_events}
          activeFilters={activeFilters}
          show={!activeFilters}
        />
        <CaseCoverageCard
          title={!activeFilters ? "Variant Coverage" : "Variants"}
          coveredTitle={!activeFilters ? "Covered Variants" : "Variants are Involved"}
          totalTitle={"Total Variants"}
          coveredPercentage={caseCoverageData?.variants_coverage_percentage}
          covered={caseCoverageData?.covered_variants}
          total={caseCoverageData?.total_variants}
          activeFilters={activeFilters}
        />
      </div>
    </div>
  )
}

export default CaseCoverage;